import React from "react";
import { PieChart } from 'react-minimal-pie-chart';

const Dunut = props => {
    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ width: '80%', height: '300px', }}>

                <PieChart
                    data={props.data}
                    lineWidth={40}
                    label={(labelProps) =>
                        <>
                            <circle
                                // cx="50%" cy="50%" 
                                r="10"
                                fill="#eee"
                                cx={labelProps.dx + 50}
                                cy={labelProps.dy + 50}
                                text-anchor={labelProps.textAnchor} />
                            <text
                                dominant-baseline="central"
                                x={labelProps.x}
                                y={labelProps.y}
                                dx={labelProps.dx}
                                dy={labelProps.dy}
                                style={{ 
                                    // fontSize: '40%', 
                                    fontSize: labelProps.dataEntry.value.toString().length > 4 ? '4.5px' : labelProps.dataEntry.value.toString().length > 3 ? '5.5' : '7px', 
                                    fontWeight: 'bold' }}
                                text-anchor={labelProps.textAnchor}>
                                {labelProps.dataEntry.value}%

                            </text>

                        </>
                    }
                    labelPosition={'80'}
                />
            </div>
        </div>
    )
}

export default Dunut